import {useQuery} from "@apollo/client";
import {GetPagesAdmin} from "./Page.js";

export function useGetPagesAdmin(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetPagesAdmin,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetPagesAdmin']) ? data : previousData;
    const extracted = (holder) ? holder['GetPagesAdmin'] : [];

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetPagesAdmin(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetPagesAdmin,
        variables
    });
    const extracted = data ? data['GetPagesAdmin'] : [];
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
